module.exports = __webpack_public_path__ + "img/professional-placeholder.d67bb687.jpg";